import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { monthEndAlertConstants } from '../../actions/constant';
import monthEndAlertsService from '../../../services/apiServices/monthEndAlert/monthEndALerts';

const {
  GET_OWNER_ALERT_COUNT_REQUEST,
  GET_OWNER_ALERT_COUNT_SUCCESS,
  GET_OWNER_ALERT_COUNT_FAILURE,
} = monthEndAlertConstants;

function* getOwnerAlertCount(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(monthEndAlertsService.getOwnerAlertCount, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_OWNER_ALERT_COUNT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_OWNER_ALERT_COUNT_FAILURE, payload: error });
  }
}

function* getOwnerAlertCountSaga() {
  yield takeEvery(GET_OWNER_ALERT_COUNT_REQUEST, getOwnerAlertCount);
}

export default getOwnerAlertCountSaga;
